import React from "react";
import { Button } from "react-bootstrap";

interface PaginationBarProps {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const PaginationBar: React.FC<PaginationBarProps> = ({
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "6px 0",
        flexWrap: "wrap",
        gap: 8,
      }}
    >
      <span style={{ fontWeight: "bold", fontSize: 13 }}>
        Total: {totalRecords}
      </span>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          style={{ fontSize: 12, padding: "2px 4px", border: "1px solid var(--border-strong)", borderRadius: 3 }}
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <Button
          size="sm"
          variant="secondary"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          style={{ padding: "2px 10px" }}
        >
          &laquo; Prev
        </Button>

        <span style={{ fontSize: 12, fontWeight: 600 }}>
          Page {currentPage} of {totalPages || 1}
        </span>

        <Button
          size="sm"
          variant="secondary"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          style={{ padding: "2px 10px" }}
        >
          Next &raquo;
        </Button>
      </div>
    </div>
  );
};

export default PaginationBar;
